/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useModal } from "../../../context/ModalContext";
import { CloseIcon } from "../../../components/Icons";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { useNavigate } from "react-router-dom";
import { modalStorageKeys } from "../../../config/params";
import { formatPetNames } from "../../../components/AvailableTimeSlots/ExpressAvailableTimeSlots";
import { markPetsShownForModal } from "../../../services/wellness-plans-by-user/wellness-plan-by-user.service";
import { PAGES_PATH } from "../../../navigation/params";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useCombinedAlertsDataStore } from "../../../hooks";
import { ICommonWPClass } from "../../../services/get-alerts/get-alerts.interface";
import WellnessRenewalPetAvatars from "../../../components/PetAvatars/WellnessRenewalPetAvatars";


const WellnessPlanEndedAlert = () => {
  const { closeModal, source } = useModal();
  const { recentlyEndedWPData, failedRenewalsAfterGracePeriodWPData } = useCombinedAlertsDataStore();
  const [petDetails, setPetDetails] = useState<ICommonWPClass[]>([]);
  const navigate = useNavigate();

  const handleModalClose = (closeFromParent?: "closeIcon" | "gotIt") =>{
    if (recentlyEndedWPData.length && (source === "nonAutoRenew")) {
      markPetsShownForModal(modalStorageKeys.nonAutoRenewEndedPlans, recentlyEndedWPData.map((petData)=>petData.petId));
    } else if (failedRenewalsAfterGracePeriodWPData.length && (source === "autoRenew")) {
      markPetsShownForModal(modalStorageKeys.autoRenewUnsuccessfulEndedPlans, failedRenewalsAfterGracePeriodWPData.map((petData)=>petData.petId));
    }
    if (closeFromParent === "closeIcon") {
      petDetails.forEach((petData)=>{
        userActivityLogger(MIXPANEL_EVENTS.PLAN_END_POP_UP_DISMISSED, {
          plan_name: petData.wellnessPlanName,
          pet_name: petData.petName,
          auto_renewal_flag: source === "autoRenew" ? "yes" : "no",
        });
      });
    } else if (closeFromParent === "gotIt") {
      petDetails.forEach((petData)=>{
        userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_GOT_IT_IN_POPUP, {
          popup_type: "plan_ended",
          auto_renewal_flag: source === "autoRenew" ? "yes" : "no",
          plan_name: petData.wellnessPlanName,
          pet_name: petData.petName,
        });
      });
    }
    closeModal();
  };
  const handlePrimaryCta = () =>{
    if (recentlyEndedWPData.length && (source === "nonAutoRenew")) {
      navigate(`${PAGES_PATH.PET_CARE}?id=${recentlyEndedWPData[0].petId}&category=TotalCare_Plan`);
    } else if (failedRenewalsAfterGracePeriodWPData.length && (source === "autoRenew")) {
      navigate(`${PAGES_PATH.PET_CARE}?id=${failedRenewalsAfterGracePeriodWPData[0].petId}&category=TotalCare_Plan`);
    }
    handleModalClose();
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_PURCHASE_PLAN_POPUP, {
      referred_from: source === "autoRenew" ? "renewal_unsuccessful_ended_popup" : "renewal_ended_popup",
    });
  };


  useEffect(()=>{
    if (recentlyEndedWPData.length && (source === "nonAutoRenew")) {
      setPetDetails(recentlyEndedWPData);
    } else if (failedRenewalsAfterGracePeriodWPData.length && (source === "autoRenew")) {
      setPetDetails(failedRenewalsAfterGracePeriodWPData);
    }
  }, []);


  return (
    <>

      {petDetails.length &&
      <div className="flex flex-col justify-between w-full h-full xl:w-[25rem]">
        <div className="flex justify-end">
          <CloseIcon
            onClick={()=>handleModalClose("closeIcon")}
            className="text-light-black cursor-pointer"
          />
        </div>
        <div className="w-full flex flex-col justify-between items-center">
          {petDetails.length &&
            <div>
              <WellnessRenewalPetAvatars petDetails={petDetails} defaultOverdueStatus={true} />
            </div>
          }
          <div className="text-xl font-semibold flex justify-center xl:w-80 text-center">
            <p>
              <span className="capitalize">{formatPetNames(petDetails.map((petData)=>petData.petName ))}</span> GoodPet+ Plan has ended
            </p>
          </div>

        </div>
        {recentlyEndedWPData.length && (source === "nonAutoRenew")?<div className="text-center pt-3 pb-4">
          To take advantage of unlimited exams, discounts on services, and coverage for routine preventative care, purchase a new plan.
        </div>:
          <div className="text-center pt-3 pb-4">
            {`We were unable to renew ${formatPetNames(petDetails.map((petData)=>petData.petName ))} plan. To take advantage of unlimited exams, discounts on services, and
          coverage for routine preventative care, purchase a new plan.`}
          </div>}

        <div className="pt-2 w-full">
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            className={"!w-full !font-semibold !border-1 !border-gray-4 hover:!text-white hover:!bg-black !h-[2.5rem] !text-sm" }
            size="small"
            onClick={handlePrimaryCta}
          >
            {"Purchase Plan"}
          </StyledBookingFlowButton>
          <div className="w-full">
            <GvSecondaryButton
              type="button"
              onClick={()=>handleModalClose("gotIt")}
              className="!w-full !font-semibold !border-1 !border-gray-4 hover:!bg-gray-3 !h-[2.5rem] !text-sm"
            >
              {"Got It"}
            </GvSecondaryButton>
          </div>
        </div>
      </div>}
    </>
  );
};

export default WellnessPlanEndedAlert;
